import { Box } from "@mui/material";
import AppBarComponent from "./components/AppBarComponent";
import FooterComponent from "./components/FooterComponent";
import BreadcrumbComponent from "./components/BreadcrumbComponent"; // Novo import
import { Outlet } from "react-router-dom";
import BannerLGPD from "../home/components/components/BannerLGPD";

const Dashboard = () => {

  return (
    <div>
      <BannerLGPD/>
      <AppBarComponent />
      <BreadcrumbComponent /> {/* Novo componente adicionado */}
      <Box
        sx={{
          marginTop: {
            xs: "55vh", // Aumentado para acomodar o breadcrumb
            sm: "40vh",
            md: "65vh",
            lg: "45vh",
            xl: "55vh",
          },
          marginBottom: {
            xs: "25vh",
            sm: "30vh",
            md: "20vh",
            lg: "20vh",
            xl: "20vh",
          },
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          
        }}
      >
        <Outlet />
      </Box>
      <FooterComponent />
    </div>
  );
};

export default Dashboard;